import { getBiVideoCardName } from '../bi-selectors/get-bi-video-card-name';
import { get } from 'lodash';
export function createVideoCardsBiLogger(logBi) {
  return {
    logCardClick(_ref) {
      let {
        card,
        biOrigin
      } = _ref;
      return logBi('widget.videoCards.card.click', {
        cardName: getBiVideoCardName(card),
        origin: biOrigin,
        socialNetwork: get(card, 'network', null)
      });
    },
    logCardCloseButtonClick(_ref2) {
      let {
        card
      } = _ref2;
      return logBi('widget.videoCards.card.close.click', {
        cardName: getBiVideoCardName(card)
      });
    },
    logAllCardsButtonClick() {
      return logBi('widget.videoCards.allCards.open.click');
    },
    logAllCardsCloseButtonClick() {
      return logBi('widget.videoCards.allCards.close.click');
    }
  };
}
//# sourceMappingURL=create-video-cards-bi-logger.js.map